<template>
  <!-- Detalle de un servicio en las plantillas 2 a 5. Los datos los calcula la página (pages/servicios/[id].vue) -->
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="servicio.Titulo" :subtitulo="servicio.Subtitulo" :imagen="servicio.ImagenPortada || P.Imagen"
      :filtro="P.ImagenFiltro" :rastro="[{ texto: tituloSeccion(NOTARIA, 'Servicios', $t), to: NOTARIA.Theme.Menu?.ShowServicios ? getLocalePath('/servicios') : undefined }, { texto: servicio.Titulo }]">
      <div v-if="solicitud" class="n2-cabeza-pagina__botones">
        <NuxtLink :to="enlaceSolicitud" class="n2-boton n2-boton--acento n2-boton--grande">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
      </div>
    </N2CabezaPagina>

    <section class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor n2-detalle" :class="{ 'n2-detalle--con-foto': servicio.Imagen }">
        <div class="n2-detalle__texto n2-texto-largo" v-thtml="servicio.Contenido"></div>
        <aside v-if="servicio.Imagen" class="n2-detalle__lateral">
          <img :src="imagenIDtoSRC(servicio.Imagen)" :alt="servicio.Titulo" loading="lazy" :style="{ filter: P.ImagenFiltro || undefined }" />
        </aside>
      </div>

      <div class="n2-contenedor">
        <!-- Hacer este encargo online (panel: Trámites online), con la documentación que pide la notaría -->
        <div v-if="solicitud" class="n2-recuadro n2-aparece">
          <div class="n2-recuadro__cuerpo">
            <p class="n2-recuadro__titulo">{{ tSolicitud('¿Quiere hacer este encargo con nosotros?') }}</p>
            <p>{{ tSolicitud('Envíenos sus datos y la documentación por internet y le contactaremos para prepararlo.') }}</p>
            <template v-if="documentos.length">
              <p class="n2-recuadro__subtitulo">{{ tSolicitud('Para empezar, tenga a mano:') }}</p>
              <ul class="n2-recuadro__docs">
                <li v-for="d in documentos" :key="d.nombre">
                  <v-icon size="18">mdi-file-document-outline</v-icon>
                  <span>{{ d.nombre }}<em v-if="!d.obligatorio"> · {{ tSolicitud('Si procede') }}</em></span>
                </li>
              </ul>
              <p class="n2-recuadro__nota">{{ tSolicitud('Puede adjuntarlos en el encargo online o aportarlos más adelante.') }}</p>
            </template>
            <NuxtLink v-if="guia" :to="guia" class="n2-enlace">{{ tSolicitud('Más información') }} <span aria-hidden="true">→</span></NuxtLink>
          </div>
          <NuxtLink :to="enlaceSolicitud" class="n2-boton n2-boton--acento n2-boton--grande">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
        </div>

        <nav v-if="anterior || siguiente" class="n2-paginacion" :aria-label="$t('Servicios')">
          <NuxtLink v-if="anterior" :to="enlace(anterior)" class="n2-paginacion__item">
            <small>← {{ $t('anterior') }}</small><strong>{{ anterior.Titulo }}</strong>
          </NuxtLink>
          <NuxtLink v-if="siguiente" :to="enlace(siguiente)" class="n2-paginacion__item n2-paginacion__item--siguiente">
            <small>{{ $t('siguiente') }} →</small><strong>{{ siguiente.Titulo }}</strong>
          </NuxtLink>
        </nav>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'

const props = defineProps({
  servicio: { type: Object, required: true },
  anterior: { type: Object, default: null },
  siguiente: { type: Object, default: null },
  /** Se llegó desde la portada: anterior y siguiente recorren los servicios de inicio. */
  desdeInicio: { type: Boolean, default: false },
  /** Se ofrece el encargo online de este servicio. */
  solicitud: { type: Boolean, default: false },
  enlaceSolicitud: { type: [String, Object], default: '' },
  documentos: { type: Array, default: () => [] },
  guia: { type: String, default: null },
})

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const raiz = ref(null)
useAparicion(raiz)

const P = computed(() => NOTARIA.value?.Theme?.Servicios ?? {})
const enlace = (s) => getLocalePath('/servicios/' + s.Slug) + (props.desdeInicio ? '?from=home' : '')
</script>
